module.exports = __webpack_public_path__ + "static/media/Plant Shop UI.9ff6e9f2.png";